/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useRef } from 'react';

export const useConstant = <T>(value: () => T): T => {
  const ref = useRef<{ v: T }>(undefined);
  if (!ref.current) {
    ref.current = { v: value() };
  }
  return ref.current.v;
};
